{
  "version": 1,
  "asset_id": "561ab62e-c38e-4eb9-b846-eca19ec1b250",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/561ab62e-c38e-4eb9-b846-eca19ec1b250/esenyurt-hizli-elektrikci-7-24-dukkan-8.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/561ab62e-c38e-4eb9-b846-eca19ec1b250/esenyurt-hizli-elektrikci-7-24-dukkan-8.jpg",
  "original_filename": "esenyurt-hizli-elektrikci-7-24-dukkan-8.jpg",
  "size": 626344,
  "content_type": "image/jpeg",
  "created_at": "2026-09-12T10:56:26Z"
}
